import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar arquivos de tradução
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationPT from './locales/pt/translation.json';

const resources = {
  'en-US': {
    translation: translationEN,
  },
  'de-DE': {
    translation: translationDE,
  },
  'pt-BR': {
    translation: translationPT,
  },
};


i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR', // Padrão, mas pode ser alterado dinamicamente
    fallbackLng: 'en-US', // Fallback para inglês
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });


export default i18n;
